import React from 'react';
import ReactDOM from 'react-dom';
import '../src/assets/css/index.scss';
import App from './App';
import {judgePlatformc} from "./env/fun.js";

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

let plat =judgePlatformc();
if(plat === 'app'){
    document.write('<script src="//j1.58cdn.com.cn/job/app/resume/delivery/1.0/js/app.bundle.js?v=' + new Date().getTime() + '"><\/script>');
}else{
    document.write('<script src="//j1.58cdn.com.cn/job/m/resume/delivery/1.1/js/app.bundle.js?v=' + new Date().getTime() + '"><\/script>');
}

